import BrandDetails from "./BrandDetails-container";

/**
 * Export the top level component BrandDetails-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default BrandDetails;
